export default "__VITE_ASSET__CCkRnp2J__"